"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const ProductFilter_1 = __importDefault(require("./ProductFilter"));
class ProductFilterModal extends react_1.default.Component {
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header znd-product-filter-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title znd-product-filter-modal__title" }, (0, translation_1.t)('product_filter_modal.title')),
                react_1.default.createElement("div", { className: "znd-modal__close znd-product-filter-modal__close", onClick: this.props.onCancel },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
            react_1.default.createElement("div", { className: "modal-body znd-modal__body znd-product-filter-modal__body" },
                react_1.default.createElement(ProductFilter_1.default, { category: this.props.category, products: this.props.products })),
            react_1.default.createElement("div", { className: "modal-footer znd-modal__footer znd-product-filter-modal__footer" },
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, text: (0, translation_1.t)('message_modal.cancel'), onClick: this.props.onCancel }),
                react_1.default.createElement(Button_1.default, { className: "znd-product-filter-modal__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('product_filter_modal.apply'), onClick: this.props.onDone }))));
    }
}
exports.default = ProductFilterModal;
